<ag-grid-angular [id]="gridId" [class]="gridClass + (hasFooter ? '' : ' no-footer')"
  [ngClass]="userPrefsService.gridTheme" [floatingFiltersHeight]="35" [rowHeight]="gridConfig.ROW_HEIGHT" animateRows
  [style]="style" [pagination]="hasFooter" [gridOptions]="gridOptions" [rowData]="rowData"
  [rowClassRules]="rowClassRules" [loading]="loading" (rowDataUpdated)="rowDataUpdated.next($event)"
  (gridReady)="onGridReady($event)" (firstDataRendered)="onFirstDataRendered()" (modelUpdated)="onModelUpdated()">
</ag-grid-angular>
<div *ngIf="hasFooter" class="grid-footer">
  <span *ngIf="footerNote">{{ footerNote }}</span>
  <a *ngIf="hasColSizeButtons" (click)="this.gridOptions.apiX?.autoSizeAllColumns()">[ Autosize Columns ]</a>
  <a *ngIf="hasColSizeButtons" class="ml-4" (click)="this.gridOptions.apiX?.sizeColumnsToFit()">[ Size to Fit ]</a>
  <a *ngIf="hasClearFiltersButton" class="ml-4" [hidden]="!hasFilters()" (click)="this.clearAllFilters()">[ Clear all
    filters ]</a>
</div>